import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useToastHandler } from "../../../common/ToastHandler";
import "../Dashboard/Invoice/Invoice.css";
import { useLocation } from "react-router-dom";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import AuthContext from "../../../../utils/secure-route/AuthContext";
import AddVendorModal from "../ReusableForm/AddVendorModal";
import LoadingOverlay from "../../../common/LoadingBar.js";
import loader from "../../../../assets/Image/Loader2.gif";
import AddExpenseTypeModal from "../ReusableForm/AddExpenseModal";
import CustomDateInput from "../../../../context/CustomDateInput";
import PaginatedSearchSelect from "../../../common/ReusableComponent/PaginatedSearchSelect/PaginatedSearchSelect";
import ChequeRenderer from '../../AppPAges/Payroll/Cheque Layout/ChequeRenderer'


function ExpenseInvoice() {
  const { Post, _Get, GetPaginatedData } = useApi();
  let { user } = useContext(AuthContext);
  const [, setIsOpen] = useState(false);
  const today = new Date().toISOString().split("T")[0];
  const [reloadData, setReloadData] = useState(false);
  const [editingInvoiceId] = useState(null);
  const [, setShowAdditionalFields] = useState(false);
  const [selectedChequeLayout, setSelectedChequeLayout] = useState(null);
  const [showModalVendor, setShowModalVendor] = useState(false);
  const [showModalExpense, setShowModalExpense] = useState(false);
  const [showCheckFields, setShowCheckFields] = useState(false);
  const [showBankFields, setShowBankFields] = useState(false);
  const [serviceData, setServiceData] = useState([]);
  const [invoices] = useState([]);
  const [reloadTotal, setReloadTotal] = useState(false);
  const dropdownRef = useRef(null);
  const storeId = user.store;
  const [selectedExpenseType, setSelectedExpenseType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [bank, setBank] = useState([]);
  const [, setActiveButton] = useState("");
  const [, setInvoicesExpense] = useState([]);
  const [, setTotalPaid] = useState(0.0);
  const [, setTotalReceivedCredit] = useState(0.0);
  const [, setTotalUnpaid] = useState(0.0);
  const [, setTotalOutstandingCredit] = useState(0.0);
  const [, setTotalDue] = useState(0.0);
  const [, setTotalCredit] = useState(0.0);
  const [, setTotalExpense] = useState(0.0);
  const location = useLocation();
  const { handleToast } = useToastHandler();

  const [formData, setFormData] = useState({
    store: storeId,
    type: "expense",
    invoice_no: "",
    date: today,
    status: "",
    pay_method_status: "pay_now",
    pay_method: "cash",
    amount: "",
    pay_amount: "",
    discount: null,
    remaining_amount: null,
    after_discount: null,
    prepaid_tax: false,
    prepaid_tax_percentage: "",
    vendor_department: "",
    vendor_department_name: "",
    vendor_department_service_titles: "",
    cheque_no: "",
    note: "",
    due_date: null,
    bank: "",
  });

  const chequePreviewData = {
    name: formData.vendor_department_name || "",
    amount: formData.amount || "0.00",
    date: formData.date || today,
    chequeNumber: formData.cheque_no || "",
  };
  const navigate = useNavigate();

  useEffect(() => {
    setActiveButton(location.pathname);
  }, [location.pathname]);

  const handleVendorAdded = (newVendor) => {
    setVendors((prevVendors) => [...prevVendors, newVendor]);
    setFormData({ ...formData, vendor_department: newVendor.id });

    const event = {
      target: {
        name: "vendor_department",
        value: newVendor.id,
      },
    };
    handleChange(event);
  };
  const handleShowVendor = () => setShowModalVendor(true);
  const handleCheckboxChange = (e) => {
    const { checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      prepaid_tax: checked,
    }));
  };


  const makeBlank = () => {
    setFormData({
      store: storeId,
      type: "expense",
      invoice_no: "",
      date: today,
      status: "",
      pay_method_status: "pay_now",
      pay_method: "cash",
      amount: "",
      pay_amount: "",
      discount: null,
      remaining_amount: null,
      after_discount: null,
      prepaid_tax: false,
      prepaid_tax_percentage: "",
      vendor_department: "",
      vendor_department_name: "",
      vendor_department_service_titles: "",
      cheque_no: "",
      note: "",
      due_date: null,
      bank: "",
      cheque_layout: null
    });
    setSelectedExpenseType(null);
    setShowCheckFields(false);
    setShowBankFields(false);
    setShowAdditionalFields(false);
  };

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      remaining_amount: prevData.amount,
    }));
  }, [formData.amount]);

  const [vendors, setVendors] = useState([]);

  const [dueDays, setDueDays] = useState([]);

  const getExpenseCalculation = async () => {
    setLoading(true);
    _Get("expenseCalculation")
      .then((response) => {
        setInvoicesExpense(response);
        setTotalPaid(response.total_paid);
        setTotalReceivedCredit(response.total_received_credit);
        setTotalUnpaid(response.total_unpaid);
        setTotalOutstandingCredit(response.total_outstanding_credit);
        setTotalDue(response.total_due);
        setTotalCredit(response.total_credit);
        setTotalExpense(response.total_purchase || 0);
      })
      .catch((error) => {
        console.error("Error fetching invoices:", error);
        handleToast({
          type: "ERROR",
          message: "Error fetching invoices:" + error,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getExpenseCalculation();
  }, [reloadTotal]);

  useEffect(() => {
    fetchData();
  }, []);

  const handleExpenseTypeSelect = (selected) => {
    if (selected) {
      if (selected.id === "add-expense" || selected.value === "add-expense") {
        setShowModalExpense(true);
        return;
      }
      
      const title = selected.title || selected.all_expense_type_detail?.title || "";
      setSelectedExpenseType(selected);
      setFormData((prevData) => ({
        ...prevData,
        vendor_department_service_titles: title,
      }));
    }else {
      setSelectedExpenseType(null);
      setFormData((prevData) => ({
        ...prevData,
        vendor_department_service_titles: "",
      }));
    }
  

  };

  const updateVendors = (newVendor) => {
    setVendors((prev) => [...prev, newVendor]);
  };

  const fetchData = async () => {
    try {
      const [vendorsResponse, serviceResponse, dueDaysResponse, bankResponse] =
        await Promise.all([
          GetPaginatedData("vendorDepartmentData", {
            page: 1,
            search: "",
            queryParams: {},
          }),
          GetPaginatedData("vendorDepartmentServiceData", {
            page: 1,
            search: "",
            queryParams: {},
          }),
          GetPaginatedData("dueDaysData", {
            page: 1,
            search: "",
            queryParams: {},
          }),
          GetPaginatedData("bank", {
            page: 1,
            search: "",
            queryParams: {},
          }),
        ]);

      const vendorsData = vendorsResponse?.data || [];
      const serviceDataRaw = serviceResponse?.data || [];
      const dueDaysData = dueDaysResponse?.data || [];
      const bankData = bankResponse?.data || [];

      // Map service data to handle new API structure
      const mappedServiceData = serviceDataRaw.map(item => {
        if (item.all_department_detail) {
          return {
            id: item.id,
            type: "department",
            title: item.all_department_detail.title,
            description: item.all_department_detail.description
          };
        }
        if (item.all_expense_type_detail) {
          return {
            id: item.id,
            type: "expense type",
            title: item.all_expense_type_detail.title,
            description: item.all_expense_type_detail.description
          };
        }
        return item;
      }).filter(Boolean);

      setVendors(vendorsData);
      setServiceData(mappedServiceData);
      setDueDays(dueDaysData);
      setBank(bankData);
    } catch (error) {
      console.error("Error fetching data:", error);
      handleToast({
        type: "ERROR",
        message: "Error fetching data:" + error,
      });
    }
  };

  const handleSpecificPaymentMethodChange = (e) => {
    const value = e.target.value;
    setShowCheckFields(value === "cheque");
    setShowBankFields(value === "bank");

    if (value !== "cheque") {
      setSelectedChequeLayout(null);
    }
    setFormData((prevData) => ({
      ...prevData,
      pay_method: value,
    }));
  };

  const handleCloseModal = () => {
    setShowModalExpense(false);
  };

  const handleCloseVendor = () => {
    setShowModalVendor(false);
  };
  const [showPaymentOptions, setShowPaymentOptions] = useState(
    formData.pay_method_status === "pay_now"
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    let updatedRemainingAmount = 0;
    if (
      formData.pay_method === "pay_later" &&
      formData.pay_method_status === "pay_later"
    ) {
      updatedRemainingAmount =
        parseFloat(formData.amount) - parseFloat(formData.pay_amount || 0);
    } else {
      updatedRemainingAmount = 0;
    }

    formData.remaining_amount =
      updatedRemainingAmount >= 0 ? updatedRemainingAmount.toFixed(2) : "0.00";

    if (!formData.vendor_department) {
      handleToast({
        type: "ERROR",
        message: "Please Select a Vendor.",
      });
      return;
    }
    if (!formData.invoice_no) {
      handleToast({
        type: "ERROR",
        message: "Invoice number is required.",
      });
      return;
    }
    if (!formData.vendor_department_service_titles) {
      handleToast({
        type: "ERROR",
        message: "Please select an expense type",
      });
      return;
    }
    if (formData.pay_method_status === "pay_later") {
      if (!formData.pay_method) {
        handleToast({
          type: "ERROR",
          message: "Please select a payment method.",
        });
        return;
      }

      if (!formData.due_date) {
        handleToast({
          type: "ERROR",
          message: "Please select a Due Date",
        });
        return;
      }
      if (!formData.amount) {
        handleToast({
          type: "ERROR",
          message: "Please fill in the Amount",
        });
        return;
      }
    }
    formData.due_date = null;
    if (formData.pay_method_status === "pay_now") {
      if (!formData.pay_method) {
        handleToast({
          type: "ERROR",
          message: "Please select a payment method.",
        });
        return;
      }

      if (formData.pay_method === "cash" && !formData.amount) {
        handleToast({
          type: "ERROR",
          message: "Please fill in the Amount.",
        });
        return;
      }

      if (formData.pay_method === "bank") {
        if (!formData.bank) {
          handleToast({
            type: "ERROR",
            message: "Please select a Bank.",
          });
          return;
        }
        if (!formData.amount) {
          handleToast({
            type: "ERROR",
            message: "Please fill in the Amount.",
          });
          return;
        }
      }

      if (formData.pay_method === "cheque") {
        if (!formData.bank) {
          handleToast({
            type: "ERROR",
            message: "Please select a Bank.",
          });
          return;
        }

        if (!formData.cheque_no) {
          handleToast({
            type: "ERROR",
            message: "Please fill in the Cheque No.",
          });
          return;
        }
        if (!formData.amount) {
          handleToast({
            type: "ERROR",
            message: "Please fill in the Amount.",
          });
          return;
        }
      }
    }


    const updatedFormData = {
      ...formData,
      amount: formData.amount,
      ...(formData.pay_method_status === "pay_now" && {
        pay_amount: formData.pay_amount || formData.amount,
      }),
    };

    if (formData.pay_method_status === "pay_now") {
      setShowPaymentOptions(true);
      updatedFormData.status = "paid";
      updatedFormData.due_date = null;
    }

    try {
      const duplicateInvoice = invoices.some(
        (invoice) => invoice.invoice_no === formData.invoice_no
      );
      if (duplicateInvoice) {
        handleToast({
          type: "ERROR",
          message: "Invoice number must be unique.",
        });
        return;
      }

      const newInvoiceData = {
        ...updatedFormData,
        cheque_layout:
          formData.pay_method === "cheque"
            ? selectedChequeLayout?.id || null
            : null,

        remaining_amount:
          formData.pay_method_status === "pay_now" ? "0.00" : formData.amount,
        status: formData.pay_method_status === "pay_now" ? "paid" : "unpaid",
      };

      const response = await Post("createInvoiceAndPrepaidTax", newInvoiceData);
      if (response.status === 200 || response.status === 201) {

        // Call cheque API if payment method is cheque
        if (formData.pay_method === "cheque") {
          const chequePayload = {
            store: storeId,
            cheque_no: formData.cheque_no,
            name: formData.vendor_department_name,
            amount: formData.amount,
            created_by: user.user_id,
          };
          await Post("chequeData", chequePayload);
        }

        handleToast({
          type: "SUCCESS",
          message: "Invoice submitted successfully!",
        });

        setTimeout(() => {
          setReloadData(!reloadData);
          setReloadTotal(!reloadTotal);
          makeBlank();
        }, 500);
      } else {
        handleToast({
          type: "ERROR",
          message: "Failed to submit invoice. Status: " + response.status,
        });
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Unknown error occurred";

      console.error("Error submitting invoice:", error);

      handleToast({
        type: "ERROR",
        message: "Failed to " + errorMessage,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const updatedData = {
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    };

    if (name === "vendor_department") {
      const selectedVendor = vendors.find((vendor) => vendor.id === value);
      updatedData.vendor_department_name = selectedVendor?.name || "";
      updatedData.vendor_department_service_titles = "";
      setSelectedExpenseType(null);
      
      if (selectedVendor) {
        const serviceTitleField =
          selectedVendor.vendor_department_service_title ||
          selectedVendor.service_titles ||
          selectedVendor.services ||
          selectedVendor.expense_types;

        const serviceIds =
          selectedVendor.vendor_department_service ||
          selectedVendor.service_ids ||
          selectedVendor.services_ids;
          
        if (serviceTitleField || serviceIds) {
          const vendorServiceTitles =
            typeof serviceTitleField === "string"
              ? serviceTitleField.split(",").map((title) => title.trim())
              : Array.isArray(serviceTitleField)
                ? serviceTitleField
                : [serviceTitleField];

          const vendorExpenseTypes = serviceData.filter((service) => {
            const isExpenseType = service.type === "expense type";

            const matchesVendorServiceByTitle = vendorServiceTitles.some(
              (vendorTitle) => {
                if (!vendorTitle || !service.title) return false;
                const vendorTitleLower = vendorTitle.toLowerCase();
                const serviceTitleLower = service.title.toLowerCase();
                const matches =
                  vendorTitleLower === serviceTitleLower ||
                  vendorTitleLower.includes(serviceTitleLower) ||
                  serviceTitleLower.includes(vendorTitleLower);
                return matches;
              }
            );

            const matchesVendorServiceById =
              serviceIds &&
              Array.isArray(serviceIds) &&
              serviceIds.some((serviceId) => {
                const matches = serviceId === service.id;
                return matches;
              });
            const matchesVendorService =
              matchesVendorServiceByTitle || matchesVendorServiceById;
            return isExpenseType && matchesVendorService;
          });

          if (vendorExpenseTypes.length > 0) {
            setSelectedExpenseType(vendorExpenseTypes[0]);
            updatedData.vendor_department_service_titles = vendorExpenseTypes[0].title;
          }
        }
      }
    }

    if (name === "days") {
      const selectedDueDays = parseInt(value, 10);
      if (!isNaN(selectedDueDays)) {
        const today = new Date();
        const dueDate = new Date(today);
        dueDate.setDate(dueDate.getDate() + selectedDueDays);
        updatedData.due_date = dueDate.toISOString().split("T")[0];
      }
    }

    if (value === "add-expense") {
      setShowModalExpense(true);
      return;
    }

    setFormData(updatedData);
  };

  const handleNewExpenseType = (newExpenseType) => {
    const newExpenseTypeData = {
      id: newExpenseType.id,
      title: newExpenseType.title,
      type: "expense type",
    };

    setServiceData((prevData) => [...prevData, newExpenseTypeData]);
    setSelectedExpenseType(newExpenseTypeData);
    setFormData((prevData) => ({
      ...prevData,
      vendor_department_service_titles: newExpenseType.title,
    }));

    setShowModalExpense(false);
  };

  const handlePaymentMethodChange = (e) => {
    const value = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      pay_method_status: value,
      pay_method:
        value === "pay_now"
          ? "cash"
          : value === "pay_later"
            ? "pay_later"
            : "credit_invoice",
      status: value === "pay_now" ? "paid" : "unpaid",
    }));

    setShowPaymentOptions(value === "pay_now");
    setShowAdditionalFields(
      value === "credit_invoice" || value === "pay_later"
    );
    setShowCheckFields(false);
    setShowBankFields(false);
  };

  const handleCancel = () => {
    makeBlank();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleLinkClick = (path) => {
    setIsOpen(false);

    navigate(path);
  };

  if (loading) {
    return (
      <LoadingOverlay loading={loading} loader={loader} />
    );
  }

  return (
    <div className="responsive-box">
      <ToastContainer />
      { }

      <div className="">
        <div className="">
          <form>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "20px",
                marginBottom: "20px",
              }}
            >
              <h3 className="mb-1" style={{ margin: "0" }}>
                Expense Invoice
              </h3>
            </div>
            <div
              className="form-row form-group col-md-12 position-relative d-flex"
              style={{ gap: "30px", marginLeft: "20px" }}
            >
              <div className="col-md-3 " style={{ paddingRight: "10px" }}>
                { }

                <CustomDateInput
                  value={formData.date || today}
                  onChange={handleChange}
                  required
                  placeholder="Select Date"
                  inputStyle={{
                    backgroundColor: "#ffffff",
                    border: "none",
                    borderBottom: "1px solid #ccc",
                    borderRadius: "0px",
                    height: "52px",
                  }}
                />
              </div>
              <div className="col-md-3" style={{ paddingRight: "10px" }}>
                <input
                  style={{
                    backgroundColor: "#ffffff",
                    border: "none",
                    borderBottom: "1px solid #ccc",
                    borderRadius: "0px",
                    height: "52px",
                    outline: "none",
                  }}
                  type="text"
                  className="form-control-borderless "
                  name="invoice_no"
                  placeholder="Invoice Number"
                  value={formData.invoice_no}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-5" style={{ paddingRight: "10px" }}>
                <select
                  style={{
                    backgroundColor: "#ffffff",
                    border: "none",
                    borderBottom: "1px solid #ccc",
                    borderRadius: "0px",
                    height: "52px",
                  }}
                  className="input-select "
                  name="vendor_department"
                  value={formData.vendor_department}
                  onChange={(e) => {
                    const selectedValue = e.target.value;
                    if (selectedValue === "add-vendor") {
                      handleShowVendor();
                      setFormData((prevData) => ({
                        ...prevData,
                        vendor_department: "",
                      }));
                    } else {
                      handleChange(e);
                    }
                  }}
                >
                  <option value="">Select Vendor</option>
                  <option value="add-vendor">Add Vendor</option>
                  {vendors && Array.isArray(vendors)
                    ? vendors
                      .filter(
                        (vendor) =>
                          vendor.type === "expense" && !vendor.is_deleted
                      )
                      .map((vendor) => (
                        <option key={vendor.id} value={vendor.id}>
                          {vendor.name}
                        </option>
                      ))
                    : null}
                </select>
              </div>
            </div>

            <div
              className="d-flex align-items-center justify-content-start col-md-12"
              style={{ gap: "30px", marginLeft: "20px", marginTop: "25px" }}
            >
              <div className="col-md-3" style={{ position: "relative" }}>
                <PaginatedSearchSelect
                  api="vendorDepartmentServiceData"
                  GetPaginatedData={GetPaginatedData}
                  placeholder="Expense Type"
                  value={selectedExpenseType}
                  getOptionLabel={(opt) => opt.title || opt.all_expense_type_detail?.title || ""}
                  onSelect={handleExpenseTypeSelect}
                  filterFn={(item) => {
                    const isExpenseType = item.all_expense_type_detail || item.type === "expense type";
                    return isExpenseType;
                  }}
                  extraOptions={[
                    { id: "add-expense", label: "+ Add Expense Type", value: "add-expense" }
                  ]}
                  
                />
              </div>

              <div
                className="form-row d-flex col-md-3"
                style={{
                  backgroundColor: "#ffffff",
                  border: "none",

                  borderRadius: "0px",
                  height: "52px",
                }}
              >
                <div className="input-group col-md-6">
                  <div
                    className="input-group-prepend"
                    style={{
                      backgroundColor: "#ffffff",
                      height: "100%",

                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    { }
                  </div>
                  <input
                    className="form-control-borderless "
                    placeholder="Amount"
                    aria-label="Amount"
                    aria-describedby="addon-wrapping"
                    name={editingInvoiceId ? "amount" : "amount"}
                    value={
                      editingInvoiceId && formData.pay_amount === undefined
                        ? formData.remaining_amount
                        : formData.amount || formData.amount
                    }
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/[^0-9.]/g, "")
                        .replace(/^(\d*\.?\d{0,2}).*/g, "$1")
                        .slice(0, 12);
                    }}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div
                style={{
                  border: "1px solid #ACB4AA",
                  padding: "8px 8px",
                  width: "fit-content",

                  borderRadius: "40px",
                  marginTop: "10px",
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                }}
              >
                <label
                  className="radio-inline"
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <input
                    type="radio"
                    name="pay_method_status"
                    value="pay_now"
                    checked={formData.pay_method_status === "pay_now"}
                    onChange={handlePaymentMethodChange}
                    style={{ display: "none" }}
                    disabled={!!editingInvoiceId}
                  />
                  <span
                    style={{
                      backgroundColor:
                        formData.pay_method_status === "pay_now"
                          ? "#4a5546"
                          : "transparent",
                      color:
                        formData.pay_method_status === "pay_now"
                          ? "#fff"
                          : "#000",
                      padding: "5px 15px",
                      borderRadius: "20px",
                      cursor: editingInvoiceId ? "not-allowed" : "pointer",
                    }}
                  >
                    Pay Now
                  </span>
                </label>

                <label
                  className="radio-inline"
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <input
                    type="radio"
                    name="pay_method_status"
                    value="pay_later"
                    checked={formData.pay_method_status === "pay_later"}
                    onChange={handlePaymentMethodChange}
                    style={{ display: "none" }}
                    disabled={!!editingInvoiceId}
                  />
                  <span
                    style={{
                      backgroundColor:
                        formData.pay_method_status === "pay_later"
                          ? "#4a5546"
                          : "transparent",
                      color:
                        formData.pay_method_status === "pay_later"
                          ? "#fff"
                          : "#000",
                      padding: "5px 15px",
                      borderRadius: "20px",
                      cursor: editingInvoiceId ? "not-allowed" : "pointer",
                    }}
                  >
                    Pay Later
                  </span>
                </label>

                <label
                  className="radio-inline"
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <input
                    type="radio"
                    name="pay_method_status"
                    value="credit_invoice"
                    checked={formData.pay_method_status === "credit_invoice"}
                    onChange={handlePaymentMethodChange}
                    style={{ display: "none" }}
                    disabled={!!editingInvoiceId}
                  />
                  <span
                    style={{
                      backgroundColor:
                        formData.pay_method_status === "credit_invoice"
                          ? "#4a5546"
                          : "transparent",
                      color:
                        formData.pay_method_status === "credit_invoice"
                          ? "#fff"
                          : "#000",
                      padding: "5px 15px",
                      borderRadius: "20px",
                      cursor: editingInvoiceId ? "not-allowed" : "pointer",
                    }}
                  >
                    Credit Invoice
                  </span>
                </label>
              </div>
            </div>

            {showPaymentOptions && (
              <div
                className="d-flex col-md-6 mb-3"
                style={{
                  border: "1px solid #ACB4AA",
                  padding: "5px 7px",
                  width: "fit-content",
                  borderRadius: "40px",
                  display: "flex",
                  gap: "10px",
                  marginTop: "35px",
                  marginLeft: "12px",
                }}
              >
                {[
                  { value: "cash", label: "Cash" },
                  { value: "cheque", label: "Check" },
                  { value: "bank", label: "Bank Card/ACH/EFT" },
                ].map((method) => (
                  <label
                    key={method.value}
                    className="radio-inline"
                    style={{
                      backgroundColor:
                        formData.pay_method === method.value
                          ? "#4a5546"
                          : "transparent",
                      color:
                        formData.pay_method === method.value
                          ? "white"
                          : "black",
                      padding: "5px 15px",
                      borderRadius: "20px",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="radio"
                      name="specificPaymentMethod"
                      value={method.value}
                      checked={formData.pay_method === method.value}
                      onChange={handleSpecificPaymentMethodChange}
                      style={{ display: "none" }}
                    />
                    {method.label}
                  </label>
                ))}
              </div>
            )}

            {(formData.pay_method_status === "pay_later" ||
              formData.pay_method_status === "credit_invoice") && (
                <div
                  className="col-md-6 d-flex"
                  style={{
                    paddingRight: "10px",
                    marginTop: "20px",
                    marginLeft: "20px",
                  }}
                >
                  <select
                    className="form-control-borderless col-md-6"
                    name="days"
                    value={formData.days || ""}
                    onChange={handleChange}
                    style={{
                      backgroundColor: "#fff",

                      border: "none",
                      borderBottom: "1px solid #ccc",
                      borderRadius: "0px",
                      height: "52px",
                    }}
                    required
                  >
                    <option value="">Select Due Days</option>
                    {dueDays.map((day) => (
                      <option key={day.id} value={day.days}>
                        {day.days}
                      </option>
                    ))}
                  </select>
                </div>
              )}

            {showCheckFields && (
              <>
                <div className="d-flex col-md-6 mb-3">
                  <div
                    className="d-flex col-md-4 mt-2"
                    style={{ marginLeft: "20px" }}
                  >
                    <select
                      style={{
                        backgroundColor: "#fff",
                        border: "none",
                        borderBottom: "1px solid #ccc",
                        borderRadius: "0px",
                        height: "52px",
                        marginRight: "10px",
                      }}
                      className="input-select"
                      name="bank"
                      value={formData.bank}
                      onChange={handleChange}
                    >
                      <option value="">Select Bank</option>
                      {bank.map((bank) => (
                        <option key={bank.id} value={bank.id}>
                          {bank.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="d-flex col-md-4 mt-2">
                    <input
                      type="text"
                      className="form-control-borderless  me-2"
                      placeholder="Check Number"
                      style={{
                        backgroundColor: "#fff",
                        border: "none",
                        borderBottom: "1px solid #ccc",
                        borderRadius: "0px",
                        height: "52px",
                        marginRight: "10px",
                      }}
                      id="checkNumber"
                      name="cheque_no"
                      value={formData.cheque_no}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (/^\d{0,15}$/.test(val)) {
                          handleChange(e);
                        }
                      }}
                      required
                    />
                  </div>
                  <div className="d-flex col-md-4 mt-2">
                    <div style={{ width: "100%", marginTop: '20px' }}>
                      {/* <label className="form-label">Cheque Layout *</label> */}
                      <PaginatedSearchSelect
                        api="preferenceCompanyData"
                        GetPaginatedData={GetPaginatedData}
                        placeholder="Select Cheque Layout"
                        value={selectedChequeLayout}
                        getOptionLabel={(opt) => opt.layout_name}
                        onSelect={(opt) => setSelectedChequeLayout(opt)}
                      />
                    </div>
                  </div>
                </div>


                <div
                  className="form-row d-flex col-md-12 "
                  style={{ marginLeft: "20px", marginBottom: "10px" }}
                >
                  <label style={{ marginTop: "15px" }}>
                    Do you want to add prepaid tax? &nbsp;
                    <input
                      type="checkbox"
                      id="prepaidTax"
                      onChange={handleCheckboxChange}
                      checked={formData.prepaid_tax}
                      name="prepaid_tax"
                    />
                  </label>
                </div>

                {formData.prepaid_tax && (
                  <div
                    className="form-row d-flex col-md-3 p-2 mt-2"
                    style={{
                      backgroundColor: "#fff",
                      border: "none",

                      borderRadius: "0px",
                      height: "52px",
                      marginLeft: "10px",
                    }}
                  >
                    <div className="input-group col-md-6">
                      <div
                        className="input-group-prepend"
                        style={{
                          // background: "#F5F5F5",
                          height: "100%",
                          borderRadius: "10px 0 0 10px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      ></div>
                      <input
                        type="text"
                        id="prepaidamountexpense"
                        className="form-control-borderless"
                        placeholder="Amount"
                        aria-label="Prepaid Tax"
                        name="prepaid_amount"
                        value={formData.prepaid_amount || ""}
                        onChange={handleChange}
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .replace(/[^0-9.]/g, "")
                            .replace(/^(\d*\.?\d{0,2}).*/g, "$1")
                            .slice(0, 12);
                        }}
                      />
                    </div>
                  </div>
                )}

                {/* Cheque Preview */}
                {selectedChequeLayout && (
                  <div className="row mt-4 mx-3">
                    <div className="col-12">
                      <h6 style={{ marginBottom: "10px" }}>Cheque Preview</h6>
                      <div
                        style={{
                          background: "#f8f9fa",
                          padding: "10px",
                          borderRadius: "8px",
                          overflowX: "auto",
                        }}
                      >
                        <ChequeRenderer
                          layout={selectedChequeLayout}
                          chequeData={chequePreviewData}
                          showPrint
                        />
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}

            {showBankFields && (
              <div className="d-flex col-md-12" style={{ marginLeft: "20px" }}>
                <div className="d-flex col-md-3">
                  <select
                    style={{
                      backgroundColor: "#fff",
                      border: "none",
                      borderBottom: "1px solid #ccc",
                      borderRadius: "0px",
                      height: "52px",
                      marginRight: "10px",
                    }}
                    className="input-select"
                    name="bank"
                    value={formData.bank}
                    onChange={handleChange}
                  >
                    <option value="">Select Bank</option>
                    {bank.map((bank) => (
                      <option key={bank.id} value={bank.id}>
                        {bank.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

          </form>

          <div className="modal-footer" style={{ border: "none", gap: "2%" }}>
            <button
              type="button"
              className="btn btn-secondary-outline"
              onClick={handleCancel}
              style={{
                border: " 1px solid #282e26",
                borderRadius: "50px",
                width: "181px",
                height: "45px",
                fontWeight: "bold",
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              style={{
                color: "white",
                backgroundColor: "#282e26",
                borderRadius: "50px",
                width: "181px",
                height: "45px",
                fontWeight: "bold",
              }}
              className="btn"
              onClick={handleSubmit}
            >
              Save
            </button>
          </div>
        </div>
      </div>
      <div>
        { }
        <AddVendorModal
          show={showModalVendor}
          handleClose={handleCloseVendor}
          onVendorAdded={handleVendorAdded}
          updateVendors={updateVendors}
        />
        <AddExpenseTypeModal
          show={showModalExpense}
          handleClose={handleCloseModal}
          onExpenseTypeAdded={handleNewExpenseType}
        />
      </div>
    </div>
  );
}

export default ExpenseInvoice;
